import { Accordion, AccordionDetails, AccordionSummary, Box, Link, Typography } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useSelector } from "react-redux";
import { StateInterface } from "./state/reducer/store";

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {"Copyright © "}
            <Link color="inherit" href="https://material-ui.com/">
                Audio Anything
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
        </Typography>
    );
}

export default function FrequentlyAskedQuestions() {
    const config = useSelector((state: StateInterface) => state.config)

    return (
        <Box style={{ maxWidth: '300px !important' }}>
            <Box>
                <Typography style={{ fontSize: '48px', letterSpacing: 4, textAlign: 'center', margin: '40px 0' }}>{config.textByLanguage.frequentlyAskedQuestions}</Typography>

            </Box>

            {/* Accordion #1 */}
            <Accordion >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography>{config.textByLanguage.faqAccordionQ1}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        {config.textByLanguage.faqAccordionA1.split(':').map(text => (
                            <li>{text}</li>
                        ))}
                    </Typography>
                </AccordionDetails>
            </Accordion>

            {/* Accordion #2 */}
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography >{config.textByLanguage.faqAccordionQ2}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        {config.textByLanguage.faqAccordionA2}
                    </Typography>
                </AccordionDetails>
            </Accordion>

            {/* Accordion #3 */}
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                >
                    <Typography >{config.textByLanguage.faqAccordionQ3}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        {config.textByLanguage.faqAccordionA3} <a href="mailto:support@audioanything.com">support@audioanything.com</a>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Box mt={5}>
                <Copyright />
            </Box>
        </Box >

    )
}
